import { render, staticRenderFns } from "./InfoAttr.vue?vue&type=template&id=6549f6e4&scoped=true"
import script from "./InfoAttr.vue?vue&type=script&lang=js"
export * from "./InfoAttr.vue?vue&type=script&lang=js"
import style0 from "./InfoAttr.vue?vue&type=style&index=0&id=6549f6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6549f6e4",
  null
  
)

export default component.exports